import React from 'react';
import { SelectionChangeFunction, Study } from '../../StudyList';
import { Button, Icon, IconList } from 'components/core';
import { requestOpenSidebar } from 'pages/StudyList/StudyListToolbar/sidebarEvents';
import { useReviewFeaturesContext } from 'contexts/ReviewFeaturesProvider';

type AddTagButtonProps = {
  studyId: Study['id'];
  onSelectionChange: SelectionChangeFunction;
};

export const AddTagButton = ({
  studyId,
  onSelectionChange,
}: AddTagButtonProps) => {
  const { hasFeature } = useReviewFeaturesContext();
  if (!hasFeature('tags_sidebar')) return null;

  return (
    <Button
      size="sm"
      type="brand"
      variant="ghost"
      onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        onSelectionChange(studyId, true);
        requestOpenSidebar({ name: 'tags', trigger: event.currentTarget });
      }}
      data-pendo-key="add-tag-button"
    >
      <Icon icon={IconList.light.faTag} />
      Add tag
    </Button>
  );
};
